import { put, call, take, fork } from 'redux-saga/effects'
import { cardSettingPatchService } from '../../api/card'
//import { questionPatchSuccess } from '../../reducers/question/action'
import { cardSettingPatchSuccess } from '../../reducers/card/action'
import { CARD_SETTING_PATCH } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* cardSettingsPatchFlow(payload) {
  try {
    const { content, questionId, settingId, key, callback } = payload
    yield put(cardSettingPatchSuccess(content, settingId, key, questionId))

    yield call(cardSettingPatchService, { data: [content], id: settingId })
    yield put(operationSuccess())

    if (key === 'badge') {
      window.badgeListNeedsRefresh = true
    }

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardSettingsPatchWatcher() {
  while (true) {
    const action = yield take(CARD_SETTING_PATCH)
    const { payload } = action

    yield fork(generalSaga, cardSettingsPatchFlow, payload, false)
  }
}
